/**
 * Программы на приёмке у владелицы: видны в меню «Программы» и на витрине
 * (/apps) ТОЛЬКО владелице и админам. Остальным их нет нигде — ни в меню,
 * ни в помощнике, ни в письмах «Что открывает ПРО»; поэтому они лежат не
 * в общем PROGRAMS (constants/programs.js), а здесь.
 *
 * Когда программа выходит ко всем — перенести запись в PROGRAMS и
 * PROGRAM_GROUPS (и в копии на бэкенде, см. комментарий там), а отсюда убрать.
 *
 * «Где тебе лучше жить» — этап 1 (01.11.2026): движок и страница без замков.
 * Сервер так же пускает только владелицу и админов (routers/where_to_live.py).
 */
export const OWNER_EMAILS = ['svetlana--2009@mail.ru'];

export const OWNER_PREVIEW_PROGRAMS = [
  {
    group: 'self',
    key: 'where_to_live',
    name: 'Где тебе лучше жить',
    path: '/where-to-live',
    level: 'free',
    emoji: '\u{1F30D}',
    menuHint: 'Карта твоих мест',
  },
];

export function canSeeOwnerPreview(user) {
  if (!user) return false;
  if ((user.role || '').toLowerCase() === 'admin') return true;
  return OWNER_EMAILS.includes(String(user.email || '').trim().toLowerCase());
}

/** Группы меню с программами на приёмке — только владелице и админам. */
export function withOwnerPreview(groups, user) {
  if (!canSeeOwnerPreview(user)) return groups;
  return groups.map((g) => {
    const extra = OWNER_PREVIEW_PROGRAMS.filter((p) => p.group === g.key);
    return extra.length ? { ...g, programs: [...g.programs, ...extra] } : g;
  });
}
